import { Density, Direction } from '@philips-internal/oswald-ui-constants';
import { ComponentAPI } from '@philips-internal/oswald-ui-core';
import { isEnumValid } from '@philips-internal/oswald-ui-utils';
class ValueListAPI extends ComponentAPI {
    getData() {
        return this.state.data;
    }
    setData(data) {
        this.setState({ data });
    }
    setDirection(direction) {
        if (!isEnumValid(Direction, direction)) {
            return;
        }
        this.setState({ direction });
    }
    getDirection() {
        return this.state.direction;
    }
    setDensity(density) {
        if (!isEnumValid(Density, density)) {
            return;
        }
        this.setState({ density });
    }
    getDensity() {
        return this.state.density;
    }
}
export default ValueListAPI;
//# sourceMappingURL=value-list-api.js.map